/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const SalaryLicensesContentContainer = styled.div`
  .card--container {
    .card--cover {
      height: 476px;

      @media (max-width: 768px) {
        height: auto;
      }

      @media (max-width: 576px) {
        height: 196px;
      }
    }
  }
`;
